import { render, staticRenderFns } from "./-table.vue?vue&type=template&id=4fb58286&scoped=true&"
import script from "./-table.vue?vue&type=script&lang=js&"
export * from "./-table.vue?vue&type=script&lang=js&"
import style0 from "./-table.vue?vue&type=style&index=0&id=4fb58286&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb58286",
  null
  
)

export default component.exports